// const stripePublishableKey = 'pk_test_qp6KKA4I8XXW6TuYVS0YTQtz00v2rmToVi'; // TEST KEY this should be moved to ENV
const stripePublishableKey = 'pk_live_sKqfW8lorDYHziPVlKDajXas00AiZvpt8C';


export {stripePublishableKey};
